/**
 * Returns true when running in a production environment.
 * Note: Next.js always sets NODE_ENV=production during `next build`,
 * so we must also check BETA_ENV to distinguish staging from production.
 */
export const isProductionEnv = () => {
  const isBeta =
    process.env.BETA_ENV === 'true' ||
    process.env.NEXT_PUBLIC_BETA_ENV === 'true';
  if (isBeta) return false;

  return (
    process.env.NODE_ENV === 'production' ||
    process.env.NEXT_PUBLIC_NODE_ENV === 'production'
  );
};
